import Vue from "vue";
import VueRouter from "vue-router";
import Index from "../Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    children: [
      {
        name: "Dashboard",
        path: "",
        component: () => import("@/views/core/Dashboard"),
      },
      {
        name: "User Profile",
        path: "/user",
        component: () => import("@/views/core/UserProfile"),
      },
      {
        name: "Congregation",
        path: "/congregation",
        component: () => import("@/views/core/Congregation"),
      },
      {
        name: "Form",
        path: "/form",
        component: () => import("@/views/core/Form"),
      },
      {
        name: "Slipi",
        path: "/slipi",
        component: () => import("@/views/core/Slipi"),
      },
      {
        name: "Kwitang",
        path: "/kwitang",
        component: () => import("@/views/core/Kwitang"),
      },
      {
        name: "BSD",
        path: "/bsd",
        component: () => import("@/views/core/BSD"),
      },
      {
        name: "Tangerang",
        path: "/tangerang",
        component: () => import("@/views/core/Tangerang"),
      },
      {
        name: "Bekasi",
        path: "/bekasi",
        component: () => import("@/views/core/Bekasi"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
